"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var common_1 = require("stremio/common");
var services_1 = require("stremio/services");
var useGeneralOptions = function (profile) {
    var core = (0, services_1.useServices)().core;
    var interfaceLanguageOptions = (0, react_1.useMemo)(function () {
        return common_1.interfaceLanguages.map(function (_a) {
            var name = _a.name, codes = _a.codes;
            return ({
                value: codes[0],
                label: name,
            });
        });
    }, []);
    var sortedOptions = (0, common_1.useLanguageSorting)(interfaceLanguageOptions).sortedOptions;
    var interfaceLanguageSelect = (0, react_1.useMemo)(function () {
        var _a, _b;
        return ({
            options: sortedOptions,
            value: ((_b = (_a = common_1.interfaceLanguages.find(function (_a) {
                var codes = _a.codes;
                return codes[1] === profile.settings.interfaceLanguage;
            })) === null || _a === void 0 ? void 0 : _a.codes) === null || _b === void 0 ? void 0 : _b[0]) ||
                profile.settings.interfaceLanguage,
            onSelect: function (value) {
                core.transport.dispatch({
                    action: 'Ctx',
                    args: {
                        action: 'UpdateSettings',
                        args: __assign(__assign({}, profile.settings), { interfaceLanguage: value })
                    }
                });
            }
        });
    }, [profile.settings, sortedOptions]);
    var escExitFullscreenToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.escExitFullscreen,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { escExitFullscreen: !profile.settings.escExitFullscreen })
                }
            });
        }
    }); }, [profile.settings]);
    var quitOnCloseToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.quitOnClose,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { quitOnClose: !profile.settings.quitOnClose })
                }
            });
        }
    }); }, [profile.settings]);
    var hideSpoilersToggle = (0, react_1.useMemo)(function () { return ({
        checked: profile.settings.hideSpoilers,
        onClick: function () {
            core.transport.dispatch({
                action: 'Ctx',
                args: {
                    action: 'UpdateSettings',
                    args: __assign(__assign({}, profile.settings), { hideSpoilers: !profile.settings.hideSpoilers })
                }
            });
        }
    }); }, [profile.settings]);
    return {
        interfaceLanguageSelect: interfaceLanguageSelect,
        escExitFullscreenToggle: escExitFullscreenToggle,
        quitOnCloseToggle: quitOnCloseToggle,
        hideSpoilersToggle: hideSpoilersToggle,
    };
};
exports.default = useGeneralOptions;
